import { CountryCode } from './type';
import type { Country } from './type';

export const malaysia: Country = {
    name: 'Malaysia',
    nameFull: 'Malaysia',
    code: CountryCode.MY,
    displayCode: CountryCode.MY,
    combinedDisplayCode: CountryCode.MY,
    makeMethod: 'makeMalaysia',
    theme: false,
    currency: 'MYR ',
    currencyName: 'MYR ',
    currencyWithCountry: 'MYR ',
    maxImageSize: 20000000, // 20MB
    imageOptions: {
        maxSize: 20000000,
        fileType: []
    },
    maxGoodNumberPerClass: 100,
    paymentMethodsImageName: 'image-4-card',
    stripeKey: import.meta.env.VITE_STRIP_PUBLIC_KEY_MY,
    autoSelectedInForm: true,
};
